import { coursewareFileTypeEnums as COURSEWARE_FILE_TYPE_ENUM, coursewareTimeUnitEnums as COURSEWARE_TIME_UNIT_ENUM } from '@/const/crud/app/course';

export function formatCourseGroup(coursewareGroups, coursewareGroupId) {
  for (const group of coursewareGroups) {
    if (group.id===coursewareGroupId) {
      return group.groupName;
    }
  }
  return '--';
}

export function convertTimeStructure(length) {
  return {
    day: parseInt(length / 86400),
    hour: parseInt((length % 86400) / 3600), 
    minute: parseInt((length % 3600) / 60), 
    second: length % 60
  }
}

export function formatCoursewareLength(type, coursewareLength) {
  switch(type) {
    case COURSEWARE_FILE_TYPE_ENUM.VIDEO.value:
      const coursewareLengthStructure = convertTimeStructure(coursewareLength);
      let coursewareLengthDisplay = '';
      if (coursewareLengthStructure.hour > 0) {
        coursewareLengthDisplay += `${coursewareLengthStructure.hour}小时`;
      }
      if (coursewareLengthStructure.minute > 0) {
        coursewareLengthDisplay += `${coursewareLengthStructure.minute}分钟`;
      }
      if (coursewareLengthStructure.second > 0) {
        coursewareLengthDisplay += `${coursewareLengthStructure.second}秒`;
      }
      return coursewareLengthDisplay;
    case COURSEWARE_FILE_TYPE_ENUM.PDF.value:
      return `${coursewareLength}页`;
    default:
  }
}

export function formatTime(length) {
  if (length === 0) {
    return '--'
  }
  const lengthStructure = convertTimeStructure(length);
  let lengthDisplay = '';
  if (lengthStructure.day > 0) {
    lengthDisplay += `${lengthStructure.day}天`;
  }
  if (lengthStructure.hour > 0) {
    lengthDisplay += `${lengthStructure.hour}小时`;
  }
  if (lengthStructure.minute > 0) {
    lengthDisplay += `${lengthStructure.minute}分钟`;
  }
  if (lengthStructure.second > 0) {
    lengthDisplay += `${lengthStructure.second}秒`;
  }
  return lengthDisplay;
}

export function getCourseTimeUnitEnum(coursewareTimeUnit) {
  for (const key in COURSEWARE_TIME_UNIT_ENUM) {
    if (COURSEWARE_TIME_UNIT_ENUM[key].value === coursewareTimeUnit) {
      return COURSEWARE_TIME_UNIT_ENUM[key];
    }
  }
}

export function parseCoursewareTime(coursewareTime) {
  for (const key in COURSEWARE_TIME_UNIT_ENUM) {
    if (coursewareTime % COURSEWARE_TIME_UNIT_ENUM[key].seconds === 0) {
      return {
        value: parseInt(coursewareTime / COURSEWARE_TIME_UNIT_ENUM[key].seconds),
        unit: COURSEWARE_TIME_UNIT_ENUM[key].value,
      }
    }
  }
}

export function formatCoursewareTime(coursewareTime) {
  for (const key in COURSEWARE_TIME_UNIT_ENUM) {
    if (coursewareTime % COURSEWARE_TIME_UNIT_ENUM[key].seconds === 0) {
      return `${parseInt(coursewareTime / COURSEWARE_TIME_UNIT_ENUM[key].seconds)}${COURSEWARE_TIME_UNIT_ENUM[key].label}`
    }
  }
}

export function caculateCoursewareTime(day, hour, minute) {
  let length = 0;
  if (day) length += day * 86400;
  if (hour) length += hour * 3600;
  if (minute) length += minute * 60;
  return length || undefined;
}

export function getPdfName(coursewareUrl) {
  let fileNameWithPrefix = coursewareUrl.substring(coursewareUrl.lastIndexOf('/'));
  fileNameWithPrefix = fileNameWithPrefix.substring(fileNameWithPrefix.indexOf('_') + 1);
  fileNameWithPrefix = decodeURIComponent(fileNameWithPrefix);
  return fileNameWithPrefix;
}